<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Client Details</h2>
        <p><strong>Client Name:</strong> {{ client.name}}</p>
        <p><strong>email:</strong> {{ client.email }}</p>
        <p><strong>Phone :</strong> {{ client.phone }}</p>
        <p><strong>Address :</strong> {{ client.address }}</p>
        <p><strong>Joined Date :</strong> {{ formatDate(client.createdAt) }}</p>
  
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Close</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        client: {
        },
    },
    data() {
      return {
      };
    },
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    },
  };
  </script>
  